import { Root } from "@radix-ui/react-accordion";

import Content from "./Content";
import Item from "./Item";
import Trigger from "./Trigger";

export const Accordion = {
  Root,
  Item,
  Trigger,
  Content,
};
